module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/3-c8596307c4a030882772df68059c9116.jpg";